import * as React from "react";
import type { SVGProps } from "react";
const SvgTwitter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    fill="none"
    {...props}
  >
    <g clipPath="url(#twitter_svg__a)">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M17.817 7.689c-.353-.509-1.297-1.222-2.826-.915-.892.18-1.425.621-1.764 1.203-.361.62-.536 1.462-.536 2.444a1 1 0 0 1-1 1c-2.366 0-4.618-.703-6.513-2.604a10.52 10.52 0 0 0-.168 2.34c.053 1.085.312 2.175.927 3.108.605.917 1.6 1.757 3.264 2.284a1 1 0 0 1 .41 1.656 8.52 8.52 0 0 1-1.796 1.405c1.06.11 2.082.117 3.03.032 1.92-.174 3.449-.723 4.405-1.5 2.013-1.633 3.09-4.066 2.89-8.144-.034-.671.613-1.394.925-1.942-.471.088-.943.071-1.248-.367ZM4.594 5.684a1 1 0 0 1 .941.429c1.476 2.158 3.248 3.056 5.214 3.26.096-.84.323-1.672.75-2.403.626-1.074 1.644-1.864 3.098-2.157 2.01-.403 3.54.325 4.427 1.216l1.792-.335A1 1 0 0 1 21.87 7.17l-1.72 3.022c.157 4.362-1.055 7.406-3.639 9.502-1.37 1.113-3.332 1.744-5.485 1.939-2.17.196-4.623-.042-7.061-.754a1 1 0 0 1 .007-1.921c1.226-.35 2.16-.65 3.003-1.177-1.199-.636-2.082-1.468-2.707-2.416-.868-1.319-1.19-2.788-1.254-4.113-.064-1.325.127-2.553.329-3.439.115-.504.249-1.01.434-1.494a1 1 0 0 1 .818-.636Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="twitter_svg__a">
        <path fill="#fff" d="M0 .7h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTwitter;
